export default "__VITE_ASSET__2d81fc1b__"